export const automationPageTableColumn: any = [
  {
    key: "checkbox",
    display_name: "",
    headerStyles: {
      background: "#7593F2",
      width: "5%",
    },
    _config: {
      type: "checkbox-conditional",
      displayInColumn: false,
      isConditionalCheck: true,
      conditionalCheck: { key: "level", value: 0 },
    },
  },
  {
    key: "expand",
    showExpand: true,
    headerStyles: {
      background: "#7593F2",
      width: "30px",
    },
  },
  {
    display_name: "Object Name",
    key: "name",
    hideForChildren: true,
    headerStyles: {
      background: "#7593F2",
      color: "#FFFFFF",
      width: "20%",
    },
  },

  // {
  //   display_name: "",
  //   key: "addLocator",
  //   headerStyles: {
  //     background: "#7593F2",
  //   },
  //   _config: {
  //     type: 'button',
  //     name: ' + New Object Locator',
  //     classNames: 'btn-accello-primary add-locator-btn '
  //   },
  // },
  {
    display_name: "Type",
    key: "type",
    headerStyles: {
      background: "#7593F2",
      color: "#FFFFFF",
      width: "15%",
    },
  },
  {
    display_name: "",
    key: "selfHealed",
    headerStyles: {
      color: "#ffffff",
      background: "#7593F2",
      width: "15%",
    },
    _config: {
      type: "conditional-button",
      name: "Self Healed",
      classNames: "btn-accello-primary self-heald",
      isConditionalCheck: true,
      conditionalCheck: { key: "selfHealed", value: true },
    },
  },
  {
    display_name: "Locator",
    key: "locator",
    headerStyles: {
      background: "#7593F2",
      width: "20%",
      color: "#FFFFFF",
    },
  },
  {
    display_name: "Locator",
    key: "addLocator",
    _config: {
      type: "conditional-button",
      name: "New Object Locator",
      isImage: true,
      imgSrc: "../../../../assets/images/virtusa-icons/add-icon-grey.svg",
      classNames: "btn-accello-light",
      isConditionalCheck: true,
      conditionalCheck: { key: "level", value: 0 },
    },
    headerStyles: {
      background: "#7593F2",
      width: "25%",
      color: "#FFFFFF",
    },
  },
  {
    display_name: "",
    key: "delete",
    _config: {
      type: "conditional-svg",
      value: "../../../../assets/images/virtusa-icons/delete-light.svg",
      classNames: "btn-accello-light",
      isConditionalCheck: true,
      conditionalCheck: { key: "level", value: 1 },
      isClickable: "true",
    },
    headerStyles: {
      background: "#7593F2",
      width: "5%",
      color: "#FFFFFF",
    },
  },
  {
    key: "edit",
    display_name: "",
    cellStyles: { "font-size": "13px" },
    headerStyles: {
      background: "#7593F2",
      color: "#FFFFFF",
      width: "4%",
    },
    _config: {
      displayInColumn: false,
      type: "svg",
      value: "../../../../assets/images/table/table-item-edit.svg",
      isClickable: "true",
    },
  },
  // {
  //   display_name: "",
  //   key: "context_menu",
  //   _config: {
  //     type: 'contextMenuByLevel',
  //     icon: 'more_horiz',
  //     options:
  //       {
  //         0: [
  //           {
  //             label: 'Remove Object',
  //             value: 'remove_object'
  //           }
  //         ],
  //         1: [
  //           {
  //             label: 'Edit',
  //             value: 'edit'
  //           },
  //           {
  //             label: 'Remove Object Locator',
  //             value: 'remove_object_locator'
  //           }
  //         ]
  //       }
  //   },
  //   iconStyles: {
  //     color: 'grey'
  //   },
  //   headerStyles: {
  //     background: "#7593F2",
  //     width: '45px',
  //     color: '#FFFFFF'
  //   }
  // }
];
